<ng-container *transloco="let t">
  <span class="workplace-info-wrapper" *ngIf="workplaceName$ | async as name" [ngbTooltip]="name" placement="bottom" triggers="click hover">
    <div class="workplace-info__message" [class.visible]="showMessage$ | async">
      <i class="material-symbols-rounded filled">info</i>
      Bylo nastaveno primární pracoviště
    </div>
    <span class="workplace-info">
      <i class="material-symbols-rounded filled text-primary">other_houses</i>
      <div class="flex-column d-none d-sm-flex">
        <span class="workplace-info__name">{{ name }}</span>
        <div class="primary-workplace text-primary">{{ t('header/primaryWorkplace') }}</div>
      </div>
    </span>
  </span>
</ng-container>
